// extracted by mini-css-extract-plugin
export default {"main":"EvaluateLayout_main__WJIt8","body":"EvaluateLayout_body__3mYlz"};